import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import * as moment from 'moment';
import { DateRangeComponent } from '../date-range/date-range.component';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subject, Subscription } from 'rxjs';
import { ApiService } from 'app/modules/shared/services/api.service';

@Component({
  selector: 'app-date-selector',
  templateUrl: './date-selector.component.html',
  styleUrls: ['./date-selector.component.scss']
})
export class DateSelectorComponent implements OnInit {

  @Output() changeDate = new EventEmitter();
  @Input() heading = 'FILTER LEADERBOARD BY DATE';
  date: any = {};
  dateRange = [
    {label: 'Day', type: 'Day', from: moment(new Date()).format('YYYY-MM-DD'), to: moment(new Date()).subtract(30, 'days').format('YYYY-MM-DD'), count: 30, apiUrl: 'userSessionsPlayedUsage'},
    {label: 'Month', type: 'Month', from: moment(new Date()).format('YYYY-MM-DD'), to: moment(new Date()).subtract(24, 'months').format('YYYY-MM-DD'), count: 24, apiUrl: 'userSessionsPlayedMonths'},
    {label: 'Year', type: 'Year', from: moment(new Date()).format('YYYY-MM-DD'), to: moment(new Date()).subtract(5, 'years').format('YYYY-MM-DD'), count: 5, apiUrl: 'userSessionsPlayedYear'},
  ];
  subSink: Subscription;
  @Input() selectedDateRange:string='Day';
  @Input() isLiveSessionAnalytics = false;
  @Input() considerDateRange = false;
  @Input() selectedDateRange$: Subject<string>=new Subject();
  constructor(private dialog: MatDialog,
    private router: Router, public api: ApiService) {
    router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if((window.location.href.includes('user/details') && !window.location.href.includes('user/details/advance/') && !window.location.href.includes('user/details/basic/') && !window.location.href.includes('isRedirection=yes')) || window.location.href.includes('main/analytics')){
        this.selectedDateRange = 'Day';
        this.date = {}
        this.changeDate.emit({type:'Day'});
        localStorage.removeItem('dateRange');
        }
      })
  }

  openDialog() {
      let start, end;
  
      if (this.selectedDateRange === 'Day') {
        start = moment().subtract(31, 'days').toDate();
        end = new Date();
      } else if (this.selectedDateRange === 'Month') {
        start = moment().subtract(24, 'months').toDate();
        end = new Date();
      } else if (this.selectedDateRange === 'Year') {
        start = moment().subtract(5, 'years').toDate();
        end = new Date();
      }

      if (this.selectedDateRange == undefined) {
        this.selectedDateRange = 'range';        
      }

      const dialogRef = this.dialog.open(DateRangeComponent, {
      width: '500px',
      // height: '410px',
      height: 'auto',
      data: {
        heading: this.heading,
        startDate: (this.date.startDate && this.selectedDateRange === 'range') ? new Date(this.date.startDate) : start,
        endDate: (this.date.endDate && this.selectedDateRange === 'range') ? new Date(this.date.endDate) : end
      }      // data: {startDate: '', endDate: ''}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.startDate !== '' && result.endDate !== '') {
          this.date = {
            startDate: moment(new Date(result.startDate)).format('MM/DD/YYYY'),
            endDate: moment(new Date(result.endDate)).format('MM/DD/YYYY')
          };
          const dateRange = {
            type: 'range',
            date: 'fromDate=' + moment(this.date.startDate).format('YYYY-MM-DD') +
              '&toDate=' + moment(this.date.endDate).format('YYYY-MM-DD'),
            startDate: result.startDate,
            endDate: result.endDate
          }

          this.selectedDateRange = 'range';
          //SG-7046
          let dateInfo:any = dateRange;
          if(!localStorage.getItem('updateDate'))
          localStorage.setItem('dateRange',JSON.stringify(dateInfo));
          this.api.datePickerData.data= dateRange;
          this.changeDate.emit(dateRange);
        }else{
          this.date = {};
        }
      }
    });
  }
  dateSelection(e) {
    this.date = {};
    this.selectedDateRange = e.type;
    //SG-7046
    let dateInfo:any = e;
    if(!localStorage.getItem('updateDate'))
    localStorage.setItem('dateRange', JSON.stringify(dateInfo));

    this.api.datePickerData.data= e;
    this.changeDate.emit(e);
  }
    //*************SG-7203 start **************

  initializeDate(e) {
    this.date = {};
    this.selectedDateRange = e.type;
    let dateInfo:any = {label: 'Day', type: 'Day', from: moment(new Date()).format('YYYY-MM-DD'), to: moment(new Date()).subtract(30, 'days').format('YYYY-MM-DD'), count: 30, apiUrl: 'userSessionsPlayedUsage'};
    if(!localStorage.getItem('dateRange'))
    localStorage.setItem('dateRange', JSON.stringify(dateInfo));
    this.api.datePickerData.data= e;
    this.changeDate.emit(e);
  }
      //*************SG-7203 end **************

  ngOnInit() {
    if (!this.isLiveSessionAnalytics) {
      this.selectedDateRange = this.api.datePickerData.type;
    } else if (this.considerDateRange) {
      let dateRange = JSON.parse(localStorage.getItem('dateRange'));
      if (dateRange.type == 'range') {
        this.date = {
          startDate:  moment(dateRange.startDate).format('MM/DD/YYYY'),
          endDate: moment(dateRange.endDate).format('MM/DD/YYYY')
          
        };
        this.selectedDateRange = 'range';
      }
    }
    this.selectedDateRange$.subscribe(v=>{
      if(v){
        this.selectedDateRange = this.api.datePickerData.type;
        const data = this.dateRange.filter(x=>x.type == v)[0]
        this.api.datePickerData = data;
        this.initializeDate(data);
      }

    })

    let appData = localStorage.getItem('dateRange');
    if(appData && !this.isLiveSessionAnalytics){
      let dateInfo = JSON.parse(appData);
      this.selectedDateRange = dateInfo.type;
      if (dateInfo.type == 'range') {

        this.date = {
          startDate:  moment(dateInfo.startDate).format('MM/DD/YYYY'),
          endDate: moment(dateInfo.endDate).format('MM/DD/YYYY')
        };
        this.selectedDateRange = 'range';
      }
      this.changeDate.emit(dateInfo);//SG-7046
    }
    this.api.dateRangeReset$.subscribe(response=>{
      if(response){
        this.api.dateRangeReset$.next(false);
        this.date = {};
        this.selectedDateRange = 'Day';
        if(response == 'Reset'){
          this.changeDate.emit({type:'Day'});
        }
      }
    })
  }

}
